import * as React from "react";
import {
  Box,
  CollectionPreferences,
  Header,
  Pagination,
  SpaceBetween,
  Table,
  TextFilter,
} from "@amzn/awsui-components-react";
import { COLUMN_DEFINITIONS } from "./recentUATTableConfig";
import { UATProject } from "../../types/UATProject";

function parseUAT(): UATProject[] {
  const uat = localStorage.getItem("UAT");
  if (uat) {
    return JSON.parse(uat) as UATProject[];
  }
  return [];
}

export default function () {
  return (
    <Table
      columnDefinitions={COLUMN_DEFINITIONS}
      columnDisplay={[
        { id: "id", visible: true },
        { id: "marketplace", visible: true },
        { id: "gl", visible: true },
        { id: "status", visible: true },
        { id: "dueDate", visible: true },
        { id: "owner", visible: true },
      ]}
      items={parseUAT()}
      loadingText="Loading resources"
      trackBy="name"
      empty={
        <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
          <SpaceBetween size="m">
            <b>No recent UATs</b>
          </SpaceBetween>
        </Box>
      }
      filter={
        <TextFilter
          filteringPlaceholder="Filter by run ID, usecase, marketplace or GL"
          filteringText=""
          countText="0 matches"
        />
      }
      header={<Header>Recent UATs</Header>}
      pagination={<Pagination currentPageIndex={1} pagesCount={2} />}
      preferences={
        <CollectionPreferences
          title="Preferences"
          confirmLabel="Confirm"
          cancelLabel="Cancel"
          preferences={{
            pageSize: 10,
            contentDisplay: [
              { id: "id", visible: true },
              { id: "marketplace", visible: true },
              { id: "gl", visible: true },
              { id: "status", visible: true },
              { id: "dueDate", visible: true },
              { id: "owner", visible: true },
            ],
          }}
          pageSizePreference={{
            title: "Page size",
            options: [
              { value: 10, label: "10 resources" },
              { value: 20, label: "20 resources" },
            ],
          }}
          wrapLinesPreference={{}}
          stripedRowsPreference={{}}
          contentDensityPreference={{}}
          contentDisplayPreference={{
            options: [
              { id: "id", label: "ID", alwaysVisible: true },
              { id: "marketplace", label: "Marketplace", alwaysVisible: true },
              { id: "gl", label: "GLPG", alwaysVisible: true },
              { id: "status", label: "Status" },
              { id: "dueDate", label: "Due Date" },
              { id: "owner", label: "Owner" },
            ],
          }}
        />
      }
    />
  );
}
